import { getIcon } from "@/config/iconMap";

const COLORS = {
  teal: "text-primary", emerald: "text-emerald-500", amber: "text-amber-500",
  sky: "text-sky-500", violet: "text-violet-500",
};

export function KpiCard({ widget }) {
  const Icon = getIcon(widget.config?.icon);
  return (
    <div
      className="bg-card rounded-xl border border-border p-5 shadow-sm hover:shadow-md transition-shadow animate-rise"
      data-testid={`widget-${widget.widgetKey}`}
    >
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{widget.title}</p>
        <Icon className={`h-5 w-5 ${COLORS[widget.config?.color] || "text-primary"}`} />
      </div>
      <p className="text-3xl font-bold text-foreground mt-3">{widget.data ?? "—"}</p>
    </div>
  );
}
